import Image from '@/components/UI/Image';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { List } from 'antd';
import { TextModule } from '..';
import css from './index.module.scss';
const defaultData = {
    guide: 'High-Efficiency Solar Cells',
    title: 'Capture more rays.',
    desc1: 'Made using highly efficient monocrystalline silicon cells. And with an exceptional energy conversion rate of 20-21%, you get more energy with every cell.',
    desc2: 'Plus, when connected to an EcoFlow solar generator, the Maximum Power Point Tracking (MPPT) algorithm auto-adjusts, guaranteeing a constant and stable power supply.',
    supliment: '* All data is gathered under test conditions.',
    items: [
        {
            url: '/img/productDetails/solarpanel/5_solar-panel.png',
            guide: 'Charge a Delta mini in',
            titleLeft: 'Approx',
            titleRight: '4hours',
            desc: 'with 6 x 60W portable solar panels.',
        },
        {
            url: '/img/productDetails/solarpanel/5_solar-panel.png',
            guide: 'Charge a Delta mini in',
            titleLeft: 'Approx',
            titleRight: '5hours',
            desc: 'with 2 x 110W portable solar panels.',
        },
        {
            url: '/img/productDetails/solarpanel/5_solar-panel.png',
            guide: 'Charge a Delta mini in',
            titleLeft: 'Approx',
            titleRight: '3.7hours',
            desc: 'with 2 x 160W portable solar panels.',
        },
        {
            url: '/img/productDetails/solarpanel/5_solar-panel.png',
            guide: 'Charge a Delta mini in',
            titleLeft: 'Approx',
            titleRight: '3hours',
            desc: 'with 1 x 400W portable solar panel.',
        },
    ],
};

export default function ImgCellsWithText({ data = defaultData, webpUrl = '' }: any) {
    const { Item } = List;
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const { EFPic } = createEFPic(webpUrl);
    return (
        <div className={`${css.imgCellsWithText} imgCellsWithText container`}>
            <TextModule
                data={{ text: data.guide }}
                cssStyle={{
                    fontClass: 'font-family-semibold',
                    margin: '60px auto 0',
                    width: '924px',
                    lineHeight: '40px',
                    fontSize: '32px',
                    textAlign: 'center',
                    fontWeight: locale === 'cn' ? 400 : 500,
                }}
            />
            <TextModule
                data={{ text: data.title }}
                cssStyle={{
                    type: 'ls',
                    fontClass: 'font-family-extrabold',
                    fontSize: locale === 'jp' ? '60px' : '64px',
                    margin: locale === 'jp' ? '14px auto 4px' : '10px auto 0',
                    width: '924px',
                    textAlign: 'center',
                    fontWeight: locale === 'cn' ? 600 : 700,
                }}
            />
            <TextModule
                data={{ text: data.desc1 }}
                cssStyle={{
                    type: 'sl',
                    fontClass: 'font-family-bold',
                    margin: locale === 'jp' ? '40px auto 90px' : '40px auto 0',
                    fontSize: locale === 'jp' ? '20px' : '22px',
                    width: '969px',
                    textAlign: 'center',
                    fontWeight: locale === 'cn' ? 500 : 600,
                }}
            />
            <TextModule
                data={{ text: data.desc2 }}
                cssStyle={{
                    type: 'sl',
                    fontClass: 'font-family-bold',
                    margin: '0 auto 90px',
                    width: locale === 'cn' ? '1060px' : '969px',
                    textAlign: 'center',
                    fontWeight: locale === 'cn' ? 500 : 600,
                }}
            />
            <List className="listBox">
                {data?.items.map((item: any, k: number) => (
                    <Item className="list" key={k}>
                        <div className="img" style={{ width: '406px', height: '214px' }}>
                            {Array.isArray(item?.url) ? <EFPic name={item.url} alt={item.guide} /> : <Image src={item.url} layout="fill" alt={item.guide} />}
                        </div>
                        <p className="guide">{item.guide}</p>
                        <p className="title font-family-bold">
                            <span className="titleLeft">{item.titleLeft}</span>
                            <span className="titleRight">{item.titleRight}</span>
                        </p>
                        <p className="desc font-family-bold">{item.desc}</p>
                    </Item>
                ))}
            </List>
            <TextModule
                data={{ text: data.supliment }}
                cssStyle={{
                    type: 'ss',
                    fontClass: 'font-family-bold',
                    margin: '12px auto 0',
                    textAlign: 'center',
                }}
            />
        </div>
    );
}
